module.exports = __webpack_public_path__ + "img/Links-to-data-center.a46f9c60.png";